import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Chip from '@mui/material/Chip';
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import CollapsibleFilterBar from '@shared/components/CollapsibleFilterBar';
import CoverageFilter from '@shared/components/CoverageFilter';
import { productTypeChipSx } from '@shared/constants/product';
import type { ProductType } from '../types';

const TYPE_OPTIONS: Array<{ label: string; value: string }> = [
  { label: 'All', value: '' },
  { label: 'AVCS', value: 'AVCS' },
  { label: 'ADP', value: 'ADP' },
  { label: 'e-NP', value: 'e-NP' },
];

interface Props {
  search: string;
  onSearchChange: (value: string) => void;
  typeFilter: string;
  onTypeFilterChange: (value: ProductType | '') => void;
  coverageFilter: string[];
  onCoverageFilterChange: (values: string[]) => void;
  activeFilterCount: number;
  onClearFilters: () => void;
  children?: React.ReactNode;
}

export default function CatalogSearch({
  search,
  onSearchChange,
  typeFilter,
  onTypeFilterChange,
  coverageFilter,
  onCoverageFilterChange,
  activeFilterCount,
  onClearFilters,
  children,
}: Props) {
  return (
    <div data-testid="catalog-search" className="flex flex-col gap-2">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <TextField
          size="small"
          placeholder="Search products..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            },
          }}
          sx={{ flex: 1 }}
        />
        {children}
      </Box>
      <CollapsibleFilterBar activeFilterCount={activeFilterCount} onClear={onClearFilters}>
        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
          {TYPE_OPTIONS.map((opt) => (
            <Chip
              key={opt.value}
              label={opt.label}
              size="small"
              variant={typeFilter === opt.value ? 'filled' : 'outlined'}
              color={opt.value ? undefined : typeFilter === opt.value ? 'primary' : 'default'}
              sx={productTypeChipSx(opt.value, typeFilter === opt.value)}
              onClick={() => onTypeFilterChange(opt.value as ProductType | '')}
            />
          ))}
        </Box>
        <Box sx={{ minWidth: 160 }}>
          <CoverageFilter value={coverageFilter} onChange={onCoverageFilterChange} />
        </Box>
      </CollapsibleFilterBar>
    </div>
  );
}
